import { combineReducers } from 'redux';
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_SUCCESS,
  CLIENT_REQUEST,
  CLIENT_SUCCESS,
  CLIENT_FAILURE,
  LANGUAGE_REQUEST,
  LANGUAGE_SUCCESS,
  LANGUAGE_FAILURE,
  POINT_OF_SALE_REQUEST,
  POINT_OF_SALE_SUCCESS,
  POINT_OF_SALE_FAILURE,
  REPORTS_REQUEST,
  REPORTS_SUCCESS,
  REPORTS_FAILURE
} from './api.actions';

function auth(
  state = {
    isFetching: false,
    isAuthenticated: sessionStorage.getItem('id_token') ? true : false
  },
  action
) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        isAuthenticated: false,
        user: action.creds
      });
    case LOGIN_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        isAuthenticated: true,
        errorMessage: ''
      });
    case LOGIN_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        isAuthenticated: false,
        errorMessage: action.message
      });
    case LOGOUT_SUCCESS:
      return Object.assign({}, state, {
        isFetching: true,
        isAuthenticated: false
      });
    default:
      return state;
  }
}

// The clients reducer
function clients(
  state = {
    isFetching: false,
    client: [],
    authenticated: false
  },
  action
) {
  switch (action.type) {
    case CLIENT_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      });
    case CLIENT_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        client: action.response,
        authenticated: action.authenticated || false
      });
    case CLIENT_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });
    default:
      return state;
  }
}

// The languages reducer
function languages(
  state = {
    isFetching: false,
    language: [],
    authenticated: false
  },
  action
) {
  switch (action.type) {
    case LANGUAGE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      });
    case LANGUAGE_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        language: action.response,
        authenticated: action.authenticated || false
      });
    case LANGUAGE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });
    default:
      return state;
  }
}

// The pointOfSales reducer
function pointOfSales(
  state = {
    isFetching: false,
    pointOfSale: undefined,
    authenticated: false
  },
  action
) {
  switch (action.type) {
    case POINT_OF_SALE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      });
    case POINT_OF_SALE_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        pointOfSale: action.response,
        authenticated: action.authenticated || false
      });
    case POINT_OF_SALE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });
    default:
      return state;
  }
}

// The Reports reducer
function reports(
  state = {
    isFetching: false,
    reports: [],
    authenticated: false
  },
  action
) {
  switch (action.type) {
    case REPORTS_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      });
    case REPORTS_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        reports: [...action.response],
        authenticated: action.authenticated || false
      });
    case REPORTS_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });
    default:
      return state;
  }
}

const frontendReducers = combineReducers({
  auth,
  clients,
  languages,
  pointOfSales,
  reports
});

export default frontendReducers;
